import styled from 'styled-components';
import { applyFlexAndCenter } from '@/styles';

export const Wrapper = styled.div`
  position: absolute;
  background-color: white;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

export const LoaderContainer = styled.div`
  position: relative;
  ${applyFlexAndCenter};
  video {
    object-fit: initial;
    width: 300px;
    height: 300px;
  }
`;
